import { render, staticRenderFns } from "./DealModal.vue?vue&type=template&id=857e8ad0&scoped=true&"
import script from "./DealModal.vue?vue&type=script&lang=js&"
export * from "./DealModal.vue?vue&type=script&lang=js&"
import style0 from "./DealModal.vue?vue&type=style&index=0&id=857e8ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857e8ad0",
  null
  
)

export default component.exports